export default "__VITE_PUBLIC_ASSET__27deb70c__"